import React from "react"
import { FormattedMessage } from "react-intl"

export const CREATE_PO_MODAL_HEADERS = [
    <FormattedMessage
        key={0}
        id="order.components.create_po_modal.headers.product_name"
        defaultMessage="Product name"
    />,
    <FormattedMessage
        key={1}
        id="order.components.create_po_modal.headers.quantity_requested"
        defaultMessage="Quantity requested"
    />,
    <FormattedMessage
        key={2}
        id="order.components.create_po_modal.headers.quantity_ordered"
        defaultMessage="Already ordered"
    />,
    <FormattedMessage
        key={3}
        id="order.components.create_po_modal.headers.quantity_to_order"
        defaultMessage="Quantity to order"
    />,
    <FormattedMessage
        key={3}
        id="order.components.create_po_modal.headers.default_supplier"
        defaultMessage="Default supplier"
    />,
]


// WEBPACK FOOTER //
// ./src/utils/order/utils.tsx